/**
 * Shared constants and styles for compliance components
 */

export const STATUS_STYLES = {
  pending: 'bg-[#FFC04D]/15 text-[#FFC04D] border-[#FFC04D]/20',
  approved: 'bg-[#1ABC9C]/15 text-[#1ABC9C] border-[#1ABC9C]/20',
  rejected: 'bg-red-500/15 text-red-400 border-red-500/20',
  expired: 'bg-gray-500/15 text-gray-400 border-gray-500/20',
};

export const COMPLIANCE_STYLES = {
  compliant: 'bg-[#1ABC9C]/15 text-[#1ABC9C] border-[#1ABC9C]/20',
  pending: 'bg-[#FFC04D]/15 text-[#FFC04D] border-[#FFC04D]/20',
  expiring_soon: 'bg-orange-500/15 text-orange-400 border-orange-500/20',
  expired: 'bg-red-500/15 text-red-400 border-red-500/20',
};

export const ACTIVATION_STYLES = {
  active: 'bg-[#1ABC9C]/15 text-[#1ABC9C] border-[#1ABC9C]/20',
  pending: 'bg-[#FFC04D]/15 text-[#FFC04D] border-[#FFC04D]/20',
  inactive: 'bg-gray-500/15 text-gray-400 border-gray-500/20',
};
